module.exports = __webpack_public_path__ + "static/media/text.1d891695.png";